import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import cn from 'classnames';
import useMediaQuery from '@restart/hooks/useMediaQuery';
import {Link} from 'react-router-dom';

import Pause from 'shared/ui/icons/Monitors/Pause';
import PauseBlack from 'shared/ui/icons/Monitors/PauseBlack';

import {formatCounter} from 'shared/lib/format/formatCounter';
import {getPausedText} from 'entities/monitor';

import styles from './MonitorInfo.module.scss';

interface MonitorInfoProps {
    classname: string,
    counter: number;
    isLink: boolean;
}

const MonitorInfo: React.FC<MonitorInfoProps> = ({counter, classname, isLink}) => {
    const isDesktop = useMediaQuery('(min-width: 621px)');

    const informerContent = (
        <div className={styles.paused_informer}>
            <div className={styles.mobileIcon}>
                <PauseBlack/>
            </div>
            <div className={styles.descIcon}>
                <Pause/>
            </div>
            <div className={styles.paused_value}>
                {formatCounter(counter, isDesktop)}
            </div>
        </div>
    );

    return (
        <div className={cn(styles.paused_wrapper, classname)}>
            <div className={cn(
                styles.title,
                styles.colorTitle,
            )}>
                {getPausedText(counter)}
            </div>
            {isLink ? (
                <Link to={AppUrls.HTTP_MONITOR_PAUSE}>
                    {informerContent}
                </Link>
            ) : (
                <span>
                    {informerContent}
                </span>
            )}
        </div>
    );
};

export default MonitorInfo;

